import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Loader from "../../Layout/Loader";
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { ArrowLeftCircle } from 'react-feather';
import { Breadcrumbs, H5 } from '../../AbstractElements';
import errorImage from "../../assets/images/blank_profile.png"
import { getCashierDetails, getData, getSubAdminDetails } from './service/manage-staff-service';
import { useLoader } from '../../_helper/LoaderContext';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { decryptResponseData } from '../../Services/decryptApiResponse';
import S3ImageLoader from '../../S3ImageLoader';

const StaffView = () => {
    const { t } = useTranslation();
    const { setLoading } = useLoader(); // Start with loading true
    const [skeletonLoading, setSkeletonLoading] = useState(true);
    const { staffId } = useParams();
    const history = useNavigate();
    const imageBaseURL = process.env.REACT_APP_IMAGE;
    const [getInfo, setInfo] = useState(null);

    useEffect(() => {
        if (!staffId) {
            history(`${process.env.PUBLIC_URL}/manage-staffs/list`);
        } else {
            getDetails();
        }
    }, [staffId]);

    const getDetails = async () => {
        try {
            setLoading(true);
            setSkeletonLoading(true);
            const requestBody = {
                subAdminId: staffId
            }
            // const response = await getData(staffId);
            const response = await getSubAdminDetails(requestBody);
            // const dec_data = decryptResponseData(response)
            if (response.data.status === 'success') {
                setInfo(response.data.data);
                setLoading(false);
                setSkeletonLoading(false);
            }
        } catch (error) {
            setLoading(false);
            setSkeletonLoading(false);
            console.error('Error fetching data:', error);
        }
    };

    const formatDate = (createdAt) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(createdAt);
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();

        // Ensure leading zeros for single-digit days
        const formattedDay = day < 10 ? '0' + day : day;
        return `${formattedDay} ${months[monthIndex]} ${year}`;
    };

    const List = () => {
        history(`${process.env.PUBLIC_URL}/manage-staffs/list`);
    };

    return (
        <Fragment>
            <Breadcrumbs mainTitle={t('View Staff Details')} parent={t('Dashboard')} title={t('View Staff Details')} />
            <div className="container mt-4">
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">{t('View Staff Details')}</h5>
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                    style={{ color: 'white', height: "40px" }}
                                    onClick={List}>
                                    <ArrowLeftCircle className="me-2" /> {t("Back")}
                                </button>
                            </CardHeader>
                            <CardBody>
                                {skeletonLoading ? (
                                    <div className="row mb-3">
                                        <div className="col-md-3 text-center">
                                            <Skeleton circle width={100} height={100} />
                                        </div>
                                        <div className="col-md-9">
                                            <Skeleton width="40%" height={24} className="mb-2" />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    {[...Array(4)].map((_, i) => (
                                                        <Skeleton key={`left-${i}`} width="100%" height={16} className="mb-1" />
                                                    ))}
                                                </div>
                                                <div className="col-md-6">
                                                    {[...Array(4)].map((_, i) => (
                                                        <Skeleton key={`right-${i}`} width="100%" height={16} className="mb-1" />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <Row>
                                        {/* Profile Picture */}
                                        <Col xs="12" md="3" className="text-center mb-3 mb-md-0">
                                            {getInfo?.contact_person.profile_picture ? (
                                                // <img
                                                //     src={imageBaseURL + getInfo?.contact_person.profile_picture}
                                                //     alt="Profile"
                                                //     className="img-fluid rounded-circle"
                                                //     style={{ width: '100px', height: "100px" }}
                                                //     onError={(e) => { e.target.src = errorImage; }} />
                                                <S3ImageLoader
                                                    className="m-0 img-fluid rounded-circle"
                                                    fileName={getInfo?.contact_person.profile_picture}
                                                    style={{ width: '100px', height: "100px" }}
                                                    alt="profile"
                                                    fallbackSrc={errorImage}
                                                />
                                            ) : (
                                                <img
                                                    src={errorImage}
                                                    className="img-fluid rounded-circle"
                                                    alt="Error"
                                                    style={{ width: '100px', height: "100px" }} />
                                            )}
                                        </Col>
                                        {/* Doctor Basic Info */}
                                        <Col xs="12" md="9">
                                            <h2>{getInfo?.contact_person.full_name || getInfo?.contact_person.first_name + " " + getInfo?.contact_person.last_name}</h2>
                                            <Row>
                                                {/* <Col xs="12" sm="6">
                                                    <p className="mb-2"><strong>{t("Designation")}:</strong> {getInfo?.designation}</p>
                                                </Col> */}
                                                {/* <Col xs="12" sm="6">
                                                    <p className="mb-2"><strong>{t("Hospital")}:</strong> {getInfo?.hospital_name}</p>
                                                </Col> */}
                                                <Col xs="12" sm="6">
                                                    <p className="mb-2"><strong>{t("Email")}:</strong> {getInfo?.email}</p>
                                                </Col>
                                                <Col xs="12" sm="6">
                                                    <p className="mb-2"><strong>{t("Mobile Number")}:</strong> {getInfo?.contact_person.phone_code} {getInfo?.contact_person.mobile}</p>
                                                </Col>
                                                <Col xs="12" sm="6">
                                                    <p className="mb-2"><strong>{t("Address")}:</strong> {getInfo?.contact_person.address}</p>
                                                </Col>
                                                {/* <Col xs="12" sm="6">
                                                    <p className="mb-2"><strong>{t("Date Of Birth")} ({t("Age")}):</strong> {formatDate(getInfo?.dob)} ({getInfo?.age} {t("Years")})</p>
                                                </Col>
                                                <Col xs="12" sm="6">
                                                    <p className="mb-2" style={{ textTransform: "capitalize" }}><strong>{t("Gender")}:</strong> {getInfo?.gender}</p>
                                                </Col> */}
                                                {/* <Col xs="12" sm="6">
                                                    <p className="mb-2 text-capitalize"><strong>{t("Role")}:</strong> {getInfo?.role}</p>
                                                </Col> */}
                                                {/* <Col xs="12" sm="6">
                                                    <p className="mb-2"><strong>{t("Address")}:</strong> {getInfo?.address}</p>
                                                </Col> */}
                                            </Row>
                                        </Col>
                                    </Row>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </Fragment>
    );
};

export default StaffView;
